import { defineComponent as _defineComponent } from 'vue'
import { downloadFileBlob } from "@/composables/helperUtils";
import TrackingService from "@/services/trackingservice/tracking.service";


export default /*#__PURE__*/_defineComponent({
  __name: 'bonus-perk',
  props: {
  content_type: {
    type: String,
    required: true,
  },
  contents: {
    type: String,
    required: false,
  },
  description: {
    type: String,
    required: true,
  },
  featuredImage: {
    type: String,
    required: false,
  },
  download: {
    type: String,
    required: true,
  },
},
  setup(__props) {

const props = __props;



const downloadPdf = async () => {
  try {
    TrackingService.trackEvent("downloadedContent", {
      contentType: props.content_type,
      content: props.contents,
      fileName: props.download,
    });

    const response = await fetch(props.download, { mode: "cors" });
    if (!response.ok) {
      console.error("Network response was not ok");
    }
    const blob = await response.blob();
    downloadFileBlob(blob, "bonus-perk.pdf");
  } catch (error) {
    console.error("Error downloading PDF:", error);
  }
};

return { __sfc: true,props, downloadPdf }
}

})